import { AuthState } from "../../../types/models/store";
import { sortByList } from "../../../views/tracks/all-tracks/contents";

const initState = {
  page: "",
  keyword: "",
  mobilemenu_toggle:0,
  track_filter: {
    genre: [],
    mood: [],
    artist: [],
    composer: [],
    tempo: [],
    keyword: "",
    sort_by: sortByList[0].value,
    isMyPage: null,
  },
  track_select: {}
};
  
  const ReduxState = (state:AuthState = initState, action: any) => {
    switch (action.type) {
      case "SET_PAGE":
        return { ...state, page: action.payload };
      case "SET_MOBILEMENU_TOGGLE":
        return { ...state, mobilemenu_toggle: action.payload };
      case "SET_KEYWORD":
        return { ...state, keyword: action.payload };
      case "SET_TRACK_FILTER":
        return {...state, track_filter: action.payload}
      case "SET_TRACK_SELECT":
        return {...state, track_select: action.payload}
      default:
        return { ...state };
    }
  };
  
  export default ReduxState;
  